import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mimeTypeIcon',
    standalone: false
})
export class MimeTypeIconPipe implements PipeTransform {
  private mimeTypeMapping: { [key: string]: string } = {
    'image/jpeg': 'image',
    'image/png': 'image',
    'image/gif': 'image',
    'application/pdf': 'picture_as_pdf',
    'text/plain': 'description',
    'application/msword': 'description',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      'description',
    'application/vnd.ms-excel': 'description',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      'description',
    'video/mp4': 'videocam',
    'video/x-msvideo': 'videocam',
    'audio/mpeg': 'music_note',
  };

  transform(mimeType: string): string {
    return this.mimeTypeMapping[mimeType] || 'description';
  }
}
